import { useMemo } from 'react';

import { getBrandValue } from '~/shared/utils/brandNameHelper';
import useProductCallout, { Callout } from '~/shared/utils/useProductCallout';

// TODO: make a cleaner version of this hook
// The hook depends on a lot of `availableQuantity` logic that we currently do not have from cio and fedGraph
// See `getAvailableProductQuantity()` in `useProductCallout.js`
export const useProductCalloutOverlay = ({ product }) => {
  const callout = useProductCallout({
    product,
    isGridCallout: true,
  });

  const calloutOverlayTypes = getBrandValue({
    savage: [Callout.COMING_SOON, Callout.SOLD_OUT],
    default: [],
  });

  const shouldShowCalloutOverlay = useMemo(() => {
    if (!callout) {
      return false;
    }

    return calloutOverlayTypes.includes(callout?.type);
  }, [callout, calloutOverlayTypes]);

  return {
    shouldShowCalloutOverlay,
    callout,
    calloutOverlayTypes,
  };
};
